{
  "progress": {
    "loading": "Carregando..."
  }
}
